import Cookies from 'js-cookie';
import React, {useContext, useEffect} from 'react';
import {handleDownloadEdapEvent, handleOnloadEdapEvent} from '../utils/triggerEdapEvent';
import {MOBILE__16} from '@homeaway/svg-defs';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {SVGIcon} from '@homeaway/react-svg';
import './AppDownloadButton.less';
import * as BannerDefaults from '../banner-defaults';
import * as BannerHelpers from '../utils/bannerHelpers';

export const AppDownloadButton = ({buttonLabel, ctaLink, travelerApp}) => {
    buttonLabel = BannerHelpers.getButtonLabel(buttonLabel);
    const context = useContext(TrackingContext);
    const brandName = BannerHelpers.getBrandName(travelerApp);
    const buttonLabelSize = buttonLabel.length;
    const btnLabelClass = buttonLabelSize > 15 ? 'app-download-button-text-small' : 'app-download-button-text';
    useEffect(() => {
        handleOnloadEdapEvent(context, BannerDefaults.BUTTON);
    }, []);
    function createLink() {
        return BannerHelpers.getDownloadLink(ctaLink, brandName, Cookies.get('hav'), Cookies.get('xdid'));
    }
    const link = createLink();

    function handleAppDownloadButtonClick() {
        handleDownloadEdapEvent(context, BannerDefaults.BUTTON);
    }
    return (<div className="app-download-button__container">

        <a className="btn btn-default app-download-button"
            href={link} target="_blank"
            onClick={handleAppDownloadButtonClick}
            data-testid="download-link"
        >
            <div className="app-download-button-content">
                <SVGIcon inlineFlex markup={MOBILE__16}/><span/>
                <span className={btnLabelClass}>{buttonLabel}</span>
            </div>
        </a>
    </div>);
};
